import {BUDGET_V2_CHART_TYPE, TABLE_TABS} from '../../../../constants';

export const TABLE_TAB_TRACKING_LABELS = {
	[TABLE_TABS.WORK_AND_EXPENSES]: 'Total price of work and expenses',
	[TABLE_TABS.WORK]: 'Work details',
	[TABLE_TABS.EXPENSES]: 'Expense details',
	[TABLE_TABS.INVOICE]: 'Invoice plan',
};

export const BUDGET_CHART_TRACKING_LABELS = {
	[BUDGET_V2_CHART_TYPE.REVENUE]: 'Revenue',
	[BUDGET_V2_CHART_TYPE.COST]: 'Cost',
	[BUDGET_V2_CHART_TYPE.PROFIT]: 'Profit',
	[BUDGET_V2_CHART_TYPE.ACTUAL_VS_PLAN]: 'Actual_variance_to_plan',
	[BUDGET_V2_CHART_TYPE.FORECAST_VS_PLAN]: 'Forecast_variance_to_plan',
	[BUDGET_V2_CHART_TYPE.INVOICE]: 'Invoice',
	[BUDGET_V2_CHART_TYPE.INVOICE_VS_ACTUAL]: 'Invoice_variance_to_actual',
	[BUDGET_V2_CHART_TYPE.TIME]: 'Time',
};
